import React from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { RadiusRingsIcon } from 'src/components/insights/icons/radius-rings'
import { INSIGHTS_TIER } from 'src/constants/insights-tier'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { Colors } from 'src/components/theme'

const RadiusRingsTradeAreaContent = dynamic(() => import('src/components/insights/radius-rings-trade-area/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const RadiusRingsTradeAreaPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  return (
    <InsightContainer insight={insight} color={Colors.blueDark}>
      <React.Suspense fallback={<FullScreenLoading />}>
        <RadiusRingsTradeAreaContent insight={insight} />
      </React.Suspense>
    </InsightContainer>
  )
}

export const RadiusRingsTradeArea: Insight = {
  id: 'radius-rings-trade-area',
  tabId: COMMANDAI_IDS_MAP.mapExplorer['radius-rings-trade-area-insights-tab'],
  component: RadiusRingsTradeAreaPage,
  name: 'Radius Rings Trade Area',
  icon: RadiusRingsIcon,
  supportedResultTypes: ['venue', 'address', 'alphamap-location'],
  linkTooltipFile: 'insights-link-radius-rings-trade-area',
  tier: INSIGHTS_TIER['Radius Rings Trade Area'],
}
